import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import MediaCard from "../components/MediaCard";
import api from "../lib/api";
import { useZoom } from "../context/ZoomContext";

export default function NewArrivals() {
  const [items, setItems] = useState([]);
  const { gridClass } = useZoom();
  useEffect(() => {
    api.get("/media", { params: { limit: 100, sort: "-created_at" } })
      .then((r) => setItems(r.data || []));
  }, []);
  return (
    <Layout>
      <section className="px-4 md:px-6 pt-10 pb-6">
        <div className="label-overline mb-3">// Recent Ingest</div>
        <h1 className="heavy text-5xl sm:text-6xl md:text-7xl">New Arrivals.</h1>
      </section>
      <section className="px-2 md:px-3 pb-16">
        {items.length === 0 ? (
          <div className="hairline p-12 text-center mx-2">
            <div className="heavy text-3xl">No media ingested yet.</div>
          </div>
        ) : (
          <div data-testid="new-arrivals-grid" className={`grid ${gridClass} gap-2 md:gap-3`}>
            {items.map((m) => <MediaCard key={m.id} media={m} />)}
          </div>
        )}
      </section>
    </Layout>
  );
}
